"use strict";

import { commonConstants, loadingSelectArray } from "../_constants";
import { isShowMainLoading } from "../../_helpers/support.services";

const INITIAL_STATE = { pendingRequests: [], show: false };

export function loadingSpinnerReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case commonConstants.ADD_PENDING_ACTIONS:
            const pendingRequests = [...state.pendingRequests, action.payload];
            const isShow = isShowMainLoading(pendingRequests);

            return {
                pendingRequests: [...pendingRequests],
                show: isShow,
            };

        case commonConstants.REMOVE_PENDING_ACTIONS:
            state = {
                ...state,
                pendingRequests: state.pendingRequests.filter(
                    (item) => item !== action.payload,
                ),
            };

            if (
                !isShowMainLoading(state.pendingRequests) ||
                state.pendingRequests.length === 0
            ) {
                state = {
                    ...state,
                    show: false,
                };
            }

            return state;

        case commonConstants.AJAX_ERROR:
            return INITIAL_STATE;

        case commonConstants.REFRESH_TOKEN_ERROR:
            return INITIAL_STATE;
    }

    return state;
}
